import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-confirmation',
  templateUrl: './product-confirmation.component.html',
  styleUrls: ['./product-confirmation.component.scss']
})
export class ProductConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
